var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnBoardingNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 11H18.0003M12.0003 14H18.0003M12.0003 17H15.0003M10.5001 7H19.5003C20.6048 7 21.5003 7.89545 21.5003 9.00004L21.5 21C21.5 22.1046 20.6046 23 19.5 23L10.5 23C9.39542 23 8.49999 22.1045 8.5 20.9999L8.50008 8.99999C8.50008 7.89542 9.39551 7 10.5001 7Z",
    stroke: "#E33745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoardingNote);
export default __webpack_public_path__ + "static/media/onBoardingNote.d565a6ef702457fe2a800f5f10757365.svg";
export { ForwardRef as ReactComponent };